// import React, { useState, useCallback, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Paper,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Button,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   CircularProgress, // Added for loader
// } from "@mui/material";
// import { styled } from "@mui/material/styles";
// import { Share, Edit, Delete } from "@mui/icons-material";
// import CreateHotlistDrawer from "./CreateHotlistDrawer";
// import ShareHotlistDrawer from "./ShareHotlistDrawer";
// import EditHotlistDrawer from "./ViewEditHotlistDrawer";
// import { fetchMyCredit } from "../../redux/credit/creditSlice";
// import { useDispatch, useSelector } from "react-redux";
// import { shortDateTime } from "../../utils/const";
// import { deleteHotList, getHotLists } from "../../redux/hotlist/hotListSlice";
// import { fontSize } from "@mui/system";

// // Custom styled components
// const HeaderPaper = styled(Paper)(({ theme }) => ({
//   padding: theme.spacing(2),
//   backgroundColor: "#f5f5f5",
//   borderRadius: 0,
//   marginBottom: theme.spacing(2),
// }));

// const TableHeaderCell = styled(TableCell)(({ theme }) => ({
//   backgroundColor: "#e5e7eb",
//   fontWeight: 600,
//   fontSize: "13px",
//   padding: "11px 14px 11px 10px",
// }));

// const TableCellStyled = styled(TableCell)(({ theme }) => ({
//   backgroundColor: "#f8f8f8",
//   fontSize: "14px",
//   padding: theme.spacing(1),
//   fontFamily: "Calibri",
// }));

// const ActionButton = styled(Button)(({ theme }) => ({
//   minWidth: "auto",
//   padding: theme.spacing(0.5),
//   backgroundColor: "#f0f0f0",
//   borderRadius: "4px",
//   "&:hover": {
//     backgroundColor: "#d0d0d0",
//   },
// }));

// // Styled component for the loader container
// const LoaderContainer = styled(Box)(({ theme }) => ({
//   display: "flex",
//   justifyContent: "center",
//   alignItems: "center",
//   minHeight: "200px", // Ensure loader is visible in the table area
// }));

// // styles.js or same file
// export const getShortBorderLeftStyle = () => ({
//   position: "relative",
//   padding: "7px 1px 7px 10px",
//   my: "2px",
//   "&::before": {
//     content: '""',
//     position: "absolute",
//     top: "15%", // top margin of the line
//     bottom: "15%", // bottom margin of the line
//     left: 0,
//     width: "1.5px",
//     backgroundColor: "#ccc",
//   },
// });

// const HotList = () => {
//   const [openDialog, setOpenDialog] = useState(false);
//   const dispatch = useDispatch();
//   const [showCreateDrawer, setShowCreateDrawer] = useState(false);
//   const [showShareDrawer, setShowShareDrawer] = useState(false);
//   const [selectedHotlist, setSelectedHotlist] = useState(null);
//   const [showEditDrawer, setShowEditDrawer] = useState(false);

//   const profile = useSelector((state) => state.profile?.data?.profile);
//   const hotListData = useSelector((state) => state.hotlist);
//   const hotlists = hotListData?.hotLists || [];
//   const hotListStatus = hotListData?.loading.getHotLists;
//   const totalCredits = useSelector(
//     (state) => state.credit.creditDetails?.data?.total_credits
//   );

//   useEffect(() => {
//     dispatch(fetchMyCredit());
//     dispatch(getHotLists());
//   }, [dispatch]);

//   const handleDeleteClick = () => {
//     setOpenDialog(true);
//   };

//   const handleConfirmDelete = () => {
//     console.log("Profile deleted", selectedHotlist?.id);
//     selectedHotlist?.id && dispatch(deleteHotList(selectedHotlist?.id));
//     setOpenDialog(false);
//   };
//   console.log(hotListStatus);

//   const handleCancelDelete = () => {
//     setOpenDialog(false);
//   };

//   const handleCloseCreateDrawer = useCallback(() => {
//     setShowCreateDrawer(false);
//     if (selectedHotlist) {
//       setShowShareDrawer(true);
//     }
//   }, [selectedHotlist]);

//   const handleCloseShareDrawer = useCallback(() => {
//     setShowShareDrawer(false);
//     setSelectedHotlist(null);
//   }, []);

//   const handleOpenCreateDrawer = () => {
//     setShowCreateDrawer(true);
//   };

//   const handleShareClick = (hotlist) => {
//     setSelectedHotlist(hotlist);
//     setShowShareDrawer(true);
//   };

//   const handleEditClick = (hotlist) => {
//     setSelectedHotlist(hotlist);
//     setShowEditDrawer(true);
//   };

//   const handleCloseEditDrawer = useCallback(() => {
//     setShowEditDrawer(false);
//     setSelectedHotlist(null);
//   }, []);

//   return (
//     <Box sx={{ padding: "14px" }}>
//       <HeaderPaper elevation={0} sx={{ py: 1, borderRadius: "2px", mb: "8px" }}>
//         <Grid container alignItems="center" justifyContent="space-between">
//           <Grid item>
//             <Typography sx={{ fontSize: "14px" }} color="text.primary">
//               <b>{profile?.full_name}</b>
//             </Typography>
//             <Typography sx={{ fontSize: "14px" }} color="text.secondary">
//               {profile?.designation} - {profile?.company_name}
//             </Typography>
//             <Typography sx={{ fontSize: "14px" }} color="text.secondary">
//               {shortDateTime(profile?.updated_at)}
//             </Typography>
//           </Grid>
//           <Grid item>
//             <Typography
//               variant="h3"
//               color="primary"
//               sx={{ fontWeight: "bold" }}
//             >
//               {totalCredits || 0}
//             </Typography>
//             <Typography sx={{ fontSize: "14px" }} color="text.secondary">
//               Credit Available
//             </Typography>
//           </Grid>
//         </Grid>
//       </HeaderPaper>

//       <Paper elevation={0}>
//         {hotListStatus === "loading" ? (
//           <LoaderContainer>
//             <CircularProgress />
//           </LoaderContainer>
//         ) : (
//           <Table
//             stickyHeader
//             aria-label="hotlist table"
//             style={{ borderSpacing: "0 2px" }}
//           >
//             <TableHead>
//               <TableRow>
//                 <TableHeaderCell>Hotlist Name</TableHeaderCell>
//                 <TableHeaderCell sx={getShortBorderLeftStyle()}>
//                   Consultants
//                 </TableHeaderCell>
//                 <TableHeaderCell sx={getShortBorderLeftStyle()}>
//                   Share
//                 </TableHeaderCell>
//                 <TableHeaderCell sx={getShortBorderLeftStyle()}>
//                   Publish
//                 </TableHeaderCell>
//                 <TableHeaderCell sx={getShortBorderLeftStyle()}>
//                   Request
//                 </TableHeaderCell>
//                 <TableHeaderCell sx={getShortBorderLeftStyle()}>
//                   Date
//                 </TableHeaderCell>
//                 <TableHeaderCell align="center" sx={getShortBorderLeftStyle()}>
//                   Action
//                 </TableHeaderCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {hotlists?.map((hotlist, index) => (
//                 <TableRow key={index}>
//                   <TableCellStyled>
//                     <Box
//                       sx={{
//                         cursor: "pointer",
//                         textDecoration: "underline",
//                         ":hover": { color: "#0d47a1" },
//                       }}
//                       onClick={() => handleEditClick(hotlist)}
//                     >
//                       {hotlist?.name}
//                     </Box>
//                   </TableCellStyled>
//                   <TableCellStyled>{hotlist.consultants}</TableCellStyled>
//                   <TableCellStyled>
//                     {hotlist?.share_to_recruiter?.length || 0}
//                   </TableCellStyled>
//                   <TableCellStyled>
//                     {hotlist?.is_publish ? "Published" : "Not Published"}
//                   </TableCellStyled>
//                   <TableCellStyled>{hotlist?.request}</TableCellStyled>
//                   <TableCellStyled>
//                     {shortDateTime(hotlist?.updated_at)}
//                   </TableCellStyled>
//                   <TableCellStyled align="right" sx={{ maxWidth: 80 }}>
//                     <ActionButton
//                       onClick={() => handleShareClick(hotlist)}
//                       color="inherit"
//                       sx={{ mr: 1 }}
//                     >
//                       <Share sx={{ color: "#f4a261" }} />
//                     </ActionButton>
//                     <ActionButton
//                       onClick={() => handleEditClick(hotlist)}
//                       color="inherit"
//                       sx={{ mr: 1 }}
//                     >
//                       <Edit sx={{ color: "#2a9d8f" }} />
//                     </ActionButton>
//                     <ActionButton onClick={handleDeleteClick} color="inherit">
//                       <Delete sx={{ color: "#e76f51" }} />
//                     </ActionButton>
//                   </TableCellStyled>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         )}
//       </Paper>

//       <Box sx={{ mt: 2, textAlign: "right" }}>
//         <Button
//           variant="contained"
//           onClick={handleOpenCreateDrawer}
//           sx={{
//             backgroundColor: "#00b050",
//             textTransform: "capitalize",
//             borderRadius: "3px",
//             boxShadow: "none",
//             padding: "8px 14px",
//             "&:hover": {
//               backgroundColor: "#00994a",
//               boxShadow: "none",
//             },
//           }}
//         >
//           Create Hotlist
//         </Button>
//       </Box>

//       <Dialog open={openDialog} onClose={handleCancelDelete}>
//         <DialogTitle>Popup</DialogTitle>
//         <DialogContent>
//           <Typography>
//             Hi, Mahesh Kumar. Are you sure, that you want to delete this
//             profile?
//           </Typography>
//         </DialogContent>
//         <DialogActions sx={{ mr: "14px", mb: "10px" }}>
//           <Button
//             variant="contained"
//             onClick={handleConfirmDelete}
//             sx={{
//               backgroundColor: "#00b0f0",
//               textTransform: "capitalize",
//               borderRadius: "3px",
//               boxShadow: "none",
//               padding: "6px 14px",
//               "&:hover": {
//                 backgroundColor: "#0085b4",
//                 boxShadow: "none",
//               },
//             }}
//           >
//             Yes
//           </Button>
//           <Button
//             variant="contained"
//             onClick={handleCancelDelete}
//             sx={{
//               backgroundColor: "#e76f51",
//               textTransform: "capitalize",
//               borderRadius: "3px",
//               boxShadow: "none",
//               padding: "6px 14px",
//               "&:hover": {
//                 backgroundColor: "#d65a4a",
//                 boxShadow: "none",
//               },
//             }}
//           >
//             No
//           </Button>
//         </DialogActions>
//       </Dialog>
//       {showCreateDrawer && (
//         <CreateHotlistDrawer
//           show={showCreateDrawer}
//           handleClose={handleCloseCreateDrawer}
//         />
//       )}

//       <ShareHotlistDrawer
//         show={showShareDrawer}
//         handleClose={handleCloseShareDrawer}
//       />

//       <EditHotlistDrawer
//         show={showEditDrawer}
//         handleClose={handleCloseEditDrawer}
//         hotlist={selectedHotlist}
//       />
//     </Box>
//   );
// };

// export default HotList;

import React, { useState, useCallback, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Share, Edit, Delete } from "@mui/icons-material";
import CreateHotlistDrawer from "./CreateHotlistDrawer";
import CreateHotlist from "./CreateHotList";
import ShareHotlistDrawer from "./ShareHotlistDrawer";
import EditHotlistDrawer from "./ViewEditHotlistDrawer";
import { fetchMyCredit } from "../../redux/credit/creditSlice";
import { useDispatch, useSelector } from "react-redux";
import { shortDateTime } from "../../utils/const";
import { deleteHotList, getHotLists } from "../../redux/hotlist/hotListSlice";
import { Icon } from "@iconify/react/dist/iconify.js";
import CandidateListDrawer from "./CandidateListDrawer";

// Custom styled components
const HeaderPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: "#f5f5f5",
  borderRadius: 0,
  marginBottom: theme.spacing(2),
}));

const TableHeaderCell = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#e5e7eb",
  fontWeight: 600,
  fontSize: "13px",
  padding: "11px 14px 11px 10px",
}));

const TableCellStyled = styled(TableCell)(({ theme }) => ({
  backgroundColor: "#f8f8f8",
  fontSize: "14px",
  padding: theme.spacing(1),
  fontFamily: "Calibri",
}));

const ActionButton = styled(Button)(({ theme }) => ({
  minWidth: "auto",
  padding: theme.spacing(0.5),
  backgroundColor: "#f0f0f0",
  borderRadius: "4px",
  "&:hover": {
    backgroundColor: "#d0d0d0",
  },
}));

const LoaderContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  minHeight: "200px",
}));

export const getShortBorderLeftStyle = () => ({
  position: "relative",
  padding: "7px 1px 7px 10px",
  my: "2px",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "15%",
    bottom: "15%",
    left: 0,
    width: "1.5px",
    backgroundColor: "#ccc",
  },
});

const HotList = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedHotlist, setSelectedHotlist] = useState(null);
  const [showCreateDrawer, setShowCreateDrawer] = useState(false);
  const [showShareDrawer, setShowShareDrawer] = useState(false);
  const [showEditDrawer, setShowEditDrawer] = useState(false);

  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile?.data?.profile);
  const hotListData = useSelector((state) => state.hotlist);
  const hotlists = hotListData?.hotLists || [];
  const hotListStatus = hotListData?.loading.getHotLists;
  const totalCredits = useSelector(
    (state) => state.credit.creditDetails?.data?.total_credits
  );

  console.log(selectedHotlist, "selectedHotlist");

  useEffect(() => {
    dispatch(fetchMyCredit());
    dispatch(getHotLists());
  }, [dispatch]);

  const handleDeleteClick = (hotlist) => {
    setSelectedHotlist(hotlist);
    setOpenDialog(true);
  };

  const handleConfirmDelete = () => {
    if (selectedHotlist?.id) {
      dispatch(deleteHotList(selectedHotlist.id));
      console.log("Deleting hotlist:", selectedHotlist.id);
    } else {
      console.error("No hotlist ID available for deletion");
    }
    setOpenDialog(false);
    setSelectedHotlist(null); // Clear selectedHotlist after deletion
  };

  const handleCancelDelete = () => {
    setOpenDialog(false);
    setSelectedHotlist(null); // Clear selectedHotlist on cancel
  };

  const handleCloseCreateDrawer = useCallback(() => {
    setShowCreateDrawer(false);
    if (selectedHotlist) {
      setShowShareDrawer(true);
    }
  }, [selectedHotlist]);

  const handleCloseShareDrawer = useCallback(() => {
    setShowShareDrawer(false);
    setSelectedHotlist(null);
  }, []);

  const handleOpenCreateDrawer = () => {
    setShowCreateDrawer(true);
  };

  const handleShareClick = (hotlist) => {
    setSelectedHotlist(hotlist);
    setShowShareDrawer(true);
  };

  const handleEditClick = (hotlist) => {
    setSelectedHotlist(hotlist);
    setShowEditDrawer(true);
  };

  const handleCloseEditDrawer = useCallback(() => {
    setShowEditDrawer(false);
    setSelectedHotlist(null);
  }, []);

  console.log(selectedHotlist);

  return (
    <Box sx={{ padding: "14px" }}>
      <HeaderPaper elevation={0} sx={{ py: 1, borderRadius: "2px", mb: "8px" }}>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Typography sx={{ fontSize: "14px" }} color="text.primary">
              <b>{profile?.full_name}</b>
            </Typography>
            <Typography sx={{ fontSize: "14px" }} color="text.secondary">
              {profile?.designation} - {profile?.company_name}
            </Typography>
            <Typography sx={{ fontSize: "14px" }} color="text.secondary">
              {shortDateTime(profile?.updated_at)}
            </Typography>
          </Grid>
          <Grid item>
            <Typography
              variant="h3"
              color="primary"
              sx={{ fontWeight: "bold" }}
            >
              {totalCredits || 0}
            </Typography>
            <Typography sx={{ fontSize: "14px" }} color="text.secondary">
              Credit Available
            </Typography>
          </Grid>
        </Grid>
      </HeaderPaper>

      <Paper elevation={0}>
        {hotListStatus === "pending" ? (
          <LoaderContainer>
            <CircularProgress />
          </LoaderContainer>
        ) : (
          <Table
            stickyHeader
            aria-label="hotlist table"
            style={{ borderSpacing: "0 2px" }}
          >
            <TableHead>
              <TableRow>
                <TableHeaderCell>Hotlist Name</TableHeaderCell>
                <TableHeaderCell sx={getShortBorderLeftStyle()}>
                  Consultants
                </TableHeaderCell>
                <TableHeaderCell sx={getShortBorderLeftStyle()}>
                  Share
                </TableHeaderCell>
                <TableHeaderCell sx={getShortBorderLeftStyle()}>
                  Publish
                </TableHeaderCell>
                <TableHeaderCell sx={getShortBorderLeftStyle()}>
                  Request
                </TableHeaderCell>
                <TableHeaderCell sx={getShortBorderLeftStyle()}>
                  Date
                </TableHeaderCell>
                <TableHeaderCell align="center" sx={getShortBorderLeftStyle()}>
                  Action
                </TableHeaderCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {hotlists?.map((hotlist) => (
                <TableRow key={hotlist.id}>
                  <TableCellStyled>
                    <Box
                      sx={{
                        cursor: "pointer",
                        textDecoration: "underline",
                        ":hover": { color: "#0d47a1" },
                      }}
                      onClick={() => handleEditClick(hotlist)}
                    >
                      {hotlist?.name}
                    </Box>
                  </TableCellStyled>
                  <TableCellStyled>
                    {hotlist?.candidate_count || 0}
                  </TableCellStyled>
                  <TableCellStyled>
                    {hotlist?.share_to_recruiter?.length || 0}
                  </TableCellStyled>
                  <TableCellStyled>
                    {hotlist?.is_publish ? "Published" : "Not Published"}
                  </TableCellStyled>
                  <TableCellStyled>{hotlist?.request || 0}</TableCellStyled>
                  <TableCellStyled>
                    {shortDateTime(hotlist?.updated_at)}
                  </TableCellStyled>
                  <TableCellStyled align="right" sx={{ maxWidth: 80 }}>
                    <ActionButton
                      onClick={() => handleShareClick(hotlist)}
                      color="inherit"
                      sx={{ mr: 1 }}
                    >
                      {" "}
                      <Icon
                        icon="fluent:share-16-regular"
                        width="20px"
                        height="20px"
                        color="#f4a261"
                      />
                      {/* <Share sx={{ color: "#f4a261" }} /> */}
                    </ActionButton>
                    <ActionButton
                      onClick={() => handleEditClick(hotlist)}
                      color="inherit"
                      sx={{ mr: 1 }}
                    >
                      <Icon
                        icon="carbon:edit"
                        width="20px"
                        height="20px"
                        color="#2a9d8f"
                      />
                      {/* <Edit sx={{ color: "#2a9d8f" }} /> */}
                    </ActionButton>
                    <ActionButton
                      onClick={() => handleDeleteClick(hotlist)}
                      color="inherit"
                    >
                      <Icon
                        icon="fluent:delete-24-regular"
                        width="20px"
                        height="20px"
                        color="#e76f51"
                      />
                      {/* <Delete sx={{ color: "#e76f51" }} /> */}
                    </ActionButton>
                  </TableCellStyled>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>

      <Box sx={{ mt: 2, textAlign: "right" }}>
        <Button
          variant="contained"
          onClick={handleOpenCreateDrawer}
          sx={{
            backgroundColor: "#00b050",
            textTransform: "capitalize",
            borderRadius: "3px",
            boxShadow: "none",
            padding: "8px 14px",
            "&:hover": {
              backgroundColor: "#00994a",
              boxShadow: "none",
            },
          }}
        >
          Create Hotlist
        </Button>
      </Box>

      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>
            Hi, {profile?.full_name || "User"}. Are you sure you want to delete
            the hotlist "{selectedHotlist?.name || "this hotlist"}"?
          </Typography>
        </DialogContent>
        <DialogActions sx={{ mr: "14px", mb: "10px" }}>
          <Button
            variant="contained"
            onClick={handleConfirmDelete}
            sx={{
              backgroundColor: "#00b0f0",
              textTransform: "capitalize",
              borderRadius: "3px",
              boxShadow: "none",
              padding: "6px 14px",
              "&:hover": {
                backgroundColor: "#0085b4",
                boxShadow: "none",
              },
            }}
          >
            Yes
          </Button>
          <Button
            variant="contained"
            onClick={handleCancelDelete}
            sx={{
              backgroundColor: "#e76f51",
              textTransform: "capitalize",
              borderRadius: "3px",
              boxShadow: "none",
              padding: "6px 14px",
              "&:hover": {
                backgroundColor: "#d65a4a",
                boxShadow: "none",
              },
            }}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {showCreateDrawer && (
        <CreateHotlist
          show={showCreateDrawer}
          handleClose={handleCloseCreateDrawer}
        />
      )}

      {showShareDrawer && (
        <ShareHotlistDrawer
          show={showShareDrawer}
          handleClose={handleCloseShareDrawer}
          hotlist={selectedHotlist}
          credit={totalCredits}
        />
      )}

      {showEditDrawer && (
        <EditHotlistDrawer
          show={showEditDrawer}
          handleClose={handleCloseEditDrawer}
          hotlist={selectedHotlist}
          date={shortDateTime(profile?.updated_at)}
          credit={totalCredits}
        />

      
      )}
    </Box>
  );
};

export default HotList;
